var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 61,
    height: 61,
    rx: 30.5,
    fill: "url(#paint0_linear_42_13517)",
    stroke: "url(#paint1_linear_42_13517)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 25.5C24 24.4856 24.3953 22.8586 25.6149 21.5034C26.7913 20.1963 28.863 19 32.5 19C36.0579 19 37.5092 20.2895 38.1976 21.4942C38.9773 22.8586 39 24.4795 39 25.5C39 26.7416 38.5959 27.433 38.014 27.9802C37.4121 28.5463 36.6308 28.961 35.6005 29.5079L35.6005 29.5079C35.4475 29.5891 35.2891 29.6732 35.125 29.7611C33.9485 30.3914 32.5427 31.1962 31.4626 32.5207C30.3408 33.8962 29.6667 35.7023 29.6667 38.1667C29.6667 38.9951 30.3382 39.6667 31.1667 39.6667C31.9951 39.6667 32.6667 38.9951 32.6667 38.1667C32.6667 36.2977 33.1592 35.1871 33.7874 34.4168C34.4573 33.5954 35.3849 33.0253 36.5417 32.4056C36.6799 32.3315 36.8239 32.2557 36.9722 32.1776L36.9722 32.1776C37.9646 31.6551 39.1482 31.0319 40.0693 30.1656C41.2374 29.067 42 27.5917 42 25.5L42 25.4473C42.0004 24.4373 42.0013 22.104 40.8024 20.0058C39.4908 17.7105 36.9421 16 32.5 16C28.137 16 25.2087 17.4703 23.3851 19.4966C21.6047 21.4748 21 23.8477 21 25.5C21 26.3284 21.6716 27 22.5 27C23.3284 27 24 26.3284 24 25.5ZM31.1667 47.5C32.6394 47.5 33.8333 46.3061 33.8333 44.8333C33.8333 43.3606 32.6394 42.1667 31.1667 42.1667C29.6939 42.1667 28.5 43.3606 28.5 44.8333C28.5 46.3061 29.6939 47.5 31.1667 47.5Z",
    fill: "url(#paint2_linear_42_13517)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_13517",
    x1: 56.96,
    y1: 0.00000108547,
    x2: -6.34387,
    y2: 28.1671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75FD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_42_13517",
    x1: 13.44,
    y1: -3.58094e-8,
    x2: 7.13874,
    y2: 61.1063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_42_13517",
    x1: 25.41,
    y1: 16,
    x2: 20.8183,
    y2: 45.6854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.7f61c1883e7b63fb24d1b98986fcfde5.svg";
export { ForwardRef as ReactComponent };